const denyList =
  <State extends { [key: string]: any }>(...keys: (keyof State)[]) =>
  (state: State) => {
    const data = Object.entries(state).filter(([key]) => !keys.includes(key));

    return Object.fromEntries(data) as State;
  };

export default denyList;
